import React from 'react';
import {Table} from "../table/Table";

class DriverRecentActivity extends React.Component {
    state = {
        recentActivityData: this.props.recentActivityData
    };

    render() {
        return (
            <>
                <Table
                    tableHeaders={[
                        "کاربر ثبت‌کننده",
                        "تاریخ ثبت",
                        "زمان ثبت",
                        "توضیحات"
                    ]}

                    tableRow={this.state.recentActivityData}

                    tableData={[
                        x => {
                            return x.memberFullName
                        },
                        x => {
                            return x.dateCreated
                        },
                        x => {
                            return x.timeCreated
                        },
                        x => {
                            return x.description
                        }
                    ]}
                />
            </>
        )
    }
}

export default DriverRecentActivity;